export default {
  guests_pay: 'Gæster betaler {{amount}} ved betaling (seneste valutakurs).',
  missing_rate: 'Ingen valutakurs for {{currency}} endnu, så gæster betaler {{amount}} uomregnet.',
};
